import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class userDataService {
  // Create a signal for the user data
  private userDataSignal = signal<any>(null);
  
  constructor(private http: HttpClient) {
    // Initialize signal with data from localStorage if available
    const storedData = localStorage.getItem('userData');
    if (storedData) {
      this.userDataSignal.set(JSON.parse(storedData));
    }
  }

  setUserData(data: any) {
    // Update localStorage
    localStorage.setItem('userData', JSON.stringify(data));
    
    // Update the signal - this will trigger updates in all components using this signal
    this.userDataSignal.set(data);
  }

  async getUserData(): Promise<any> {
    const current = this.userDataSignal();
    if (current) return current;
    try {
      const user = await firstValueFrom(this.http.get(`${environment.apiUrl}/users/me`));
      this.setUserData(user);
      return user;
    } catch (error) {
      console.error('Failed to fetch user data from API:', error);
      return null;
    }
  }
  
  // This allows components to subscribe to changes
  getUserDataSignal() {
    return this.userDataSignal;
  }
}